export interface DashSegment {
  x: number;
  width: number;
}

export interface FixedEndDashOptions {
  endDash?: number;
  dash?: number;
  minGap?: number;
  maxGap?: number;
}

function resolveMiddleDashLayout(
  totalWidth: number,
  endDash: number,
  dash: number,
  minGap: number,
  maxGap: number,
): { middleCount: number; gap: number } {
  const maxMiddleCount = Math.max(
    0,
    Math.floor((totalWidth - endDash * 2 - minGap) / (dash + minGap)),
  );

  for (let middleCount = maxMiddleCount; middleCount >= 0; middleCount--) {
    const gapCount = middleCount + 1;
    const gap = (totalWidth - endDash * 2 - middleCount * dash) / gapCount;

    if (gap >= minGap && gap <= maxGap) {
      return { middleCount, gap };
    }
  }

  for (let middleCount = maxMiddleCount; middleCount >= 0; middleCount--) {
    const gapCount = middleCount + 1;
    const gap = (totalWidth - endDash * 2 - middleCount * dash) / gapCount;

    if (gap >= minGap) {
      return { middleCount, gap };
    }
  }

  return {
    middleCount: 0,
    gap: Math.min(maxGap, Math.max(minGap, totalWidth - endDash * 2)),
  };
}

export function buildFixedEndDashSegments(
  totalWidth: number,
  options: FixedEndDashOptions = {},
): DashSegment[] {
  const endDash = options.endDash ?? 2;
  const dash = options.dash ?? 4;
  const minGap = options.minGap ?? 3;
  const maxGap = options.maxGap ?? 4;

  if (totalWidth <= 0) return [];

  const minWidth = endDash * 2 + minGap;
  if (totalWidth < minWidth) return [{ x: 0, width: totalWidth }];

  const { middleCount, gap } = resolveMiddleDashLayout(
    totalWidth,
    endDash,
    dash,
    minGap,
    maxGap,
  );

  const segments: DashSegment[] = [];
  let x = 0;

  segments.push({ x, width: endDash });
  x += endDash + gap;

  for (let i = 0; i < middleCount; i++) {
    segments.push({ x, width: dash });
    x += dash + gap;
  }

  segments.push({ x, width: endDash });

  return segments;
}
